import * as React from "react";

const SvgSmartphone = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 548.8 548.8"
    style={{
      enableBackground: "new 0 0 548.8 548.8",
    }}
    xmlSpace="preserve"
    {...props}
  >
    <path d="m359.4 37.3-184.7 1.2c-15.4.1-28.7 12.7-28.6 28.9l2.7 418.9c.1 15.4 12.7 28.7 28.9 28.6l184.7-1.2c15.4-.1 28.7-12.7 28.6-28.9l-2.7-418.9c-.1-15.4-12.7-28.7-28.9-28.6zM225.1 65.5l83.5-.5c2.9 0 5.2 2.2 5.2 5.1s-2.2 5.2-5.1 5.2l-83.5.5c-2.2 0-4.5-2.2-5.2-5.1 0-2.9 2.2-5.2 5.1-5.2zM270 498.1c-11 .1-20-8.8-20.1-19.8-.1-11.1 8.8-20 19.8-20.1 11-.1 20 8.8 20.1 19.8 0 11.2-8.9 20.1-19.8 20.1zm97.1-63.4-194.4 1.2-2.2-336.2 194.4-1.2 2.2 336.2z" />
  </svg>
);

export default SvgSmartphone;
